import * as types from '../types/contactTypes';

const initialState = {
  loading: false,
  messageSent: false,
  messages: [],
  message: null,
  unreadCount: {
    unread: 0,
    unreplied: 0
  },
  pagination: {
    page: 1,
    limit: 20,
    total: 0,
    pages: 0
  },
  error: null,
};

const contactReducer = (state = initialState, action) => {
  switch (action.type) {
    // SEND CONTACT MESSAGE
    case types.SEND_CONTACT_MESSAGE_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case types.SEND_CONTACT_MESSAGE_SUCCESS:
      return {
        ...state,
        loading: false,
        messageSent: true,
        error: null,
      };
    case types.SEND_CONTACT_MESSAGE_FAILURE:
      return {
        ...state,
        loading: false,
        messageSent: false,
        error: action.payload,
      };

    // FETCH CONTACT MESSAGES
    case types.FETCH_CONTACT_MESSAGES_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case types.FETCH_CONTACT_MESSAGES_SUCCESS:
      return {
        ...state,
        loading: false,
        messages: Array.isArray(action.payload) ? action.payload : action.payload.data || [],
        pagination: action.payload.pagination || state.pagination,
        error: null,
      };
    case types.FETCH_CONTACT_MESSAGES_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    // FETCH CONTACT MESSAGE
    case types.FETCH_CONTACT_MESSAGE_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case types.FETCH_CONTACT_MESSAGE_SUCCESS:
      return {
        ...state,
        loading: false,
        message: action.payload.data || action.payload,
        error: null,
      };
    case types.FETCH_CONTACT_MESSAGE_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    // MARK MESSAGE AS READ
    case types.MARK_MESSAGE_AS_READ_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case types.MARK_MESSAGE_AS_READ_SUCCESS:
      const readMessage = action.payload.data || action.payload;
      return {
        ...state,
        loading: false,
        messages: state.messages.map(msg => 
          msg._id === readMessage._id ? { ...msg, read: true } : msg
        ),
        message: state.message?._id === readMessage._id ? { ...state.message, read: true } : state.message,
        error: null,
      };
    case types.MARK_MESSAGE_AS_READ_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    // MARK MESSAGE AS REPLIED
    case types.MARK_MESSAGE_AS_REPLIED_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case types.MARK_MESSAGE_AS_REPLIED_SUCCESS:
      const repliedMessage = action.payload.data || action.payload;
      return {
        ...state,
        loading: false,
        messages: state.messages.map(msg => 
          msg._id === repliedMessage._id ? { ...msg, replied: true } : msg
        ),
        message: state.message?._id === repliedMessage._id ? { ...state.message, replied: true } : state.message,
        error: null,
      };
    case types.MARK_MESSAGE_AS_REPLIED_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    // DELETE CONTACT MESSAGE
    case types.DELETE_CONTACT_MESSAGE_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case types.DELETE_CONTACT_MESSAGE_SUCCESS:
      return {
        ...state,
        loading: false,
        messages: state.messages.filter(msg => msg._id !== action.payload),
        error: null,
      };
    case types.DELETE_CONTACT_MESSAGE_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    // FETCH UNREAD COUNT
    case types.FETCH_UNREAD_COUNT_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case types.FETCH_UNREAD_COUNT_SUCCESS:
      return {
        ...state,
        loading: false,
        unreadCount: action.payload.data || action.payload,
        error: null,
      };
    case types.FETCH_UNREAD_COUNT_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    default:
      return state;
  }
};

export default contactReducer;


